import BackdropModal from './backdrop-modal';

export default BackdropModal;
